* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.flexible-table {
  display: flex;
  flex-direction: column;

  font-size: var(--body-size);
  font-weight: var(--font-wight, 500);

  &__row {
    display: flex;
    flex-wrap: wrap;

    &:hover {
      background-color: var(--chart-050-hover);
    }

    &:hover {
      gz-select {
        visibility: visible;
      }
    }
  }

  &__cell {
    display: flex;
    flex: 1;
    align-items: flex-start;

    padding: calc(var(--spacer) * 0.5);

    color: var(--body-text-arrows-400);
    word-break: break-all;

    &--header {
      color: var(--chart-300-icon-buttons);
    }

    & > * {
      align-self: flex-start;
    }
  }

  &__cell-extra {
    flex: 0 1 auto;
    margin-left: auto;
    width: 116px;
  }

  gz-select {
    visibility: hidden;
  }
}

.expandable-cell-content {
  position: relative;
  flex: 1;
}

.multiple-value__text {
  max-width: 75%;
}

.multiple-value__counter {
  padding-left: var(--spacer);
}

.icon-move-up {
  margin-left: auto;
  margin-right: calc(var(--spacer) * 0.5);
}

.multiple-value-container {
  display: flex;
  flex: 1;
}

.action-template-container {
  margin-left: auto;
  position: relative;
}

.cursor-pointer {
  cursor: pointer;
}
